module.exports = __webpack_public_path__ + "images/Sprout_Social-072fcb.png";